export default __webpack_public_path__ + "static/media/airbnb.69ba03d9.png";